export default "__VITE_PUBLIC_ASSET__fbaafae3__"